<div class="content">
  <h1>{{ "Form.Title" | translate }}</h1>
  <!-- teste -->
  <div class="blue-line"></div>
  <form #f="ngForm" (ngSubmit)="onSubmit(f)" autocomplete="off">
    <div class="table-form">
      <div class="first-form">
        <table class="username" cellspacing="0">
          <tr>
            <td>
              <mat-form-field class="full-width">
                <mat-label>{{ "Form.Field.Requester" | translate }}</mat-label>
                <input
                  id="name"
                  matInput
                  readonly
                  name="name"
                  [(ngModel)]="form.name"
                />
                {{ (userData$ | async)?.name }}
              </mat-form-field>
            </td>

            <td class="">
              <mat-form-field class="selection" appearance="fill">
                <mat-label>{{ "Form.Field.country" | translate }}</mat-label>
                <mat-select
                  id="country"
                  name="country"
                  [(ngModel)]="form.country"
                  required
                >
                  <mat-option
                    *ngFor="let countryvalue of CountryValues"
                    value="{{ countryvalue.key }}"
                  >
                    {{ countryvalue.label | translate }}
                  </mat-option>
                </mat-select>
                <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
              </mat-form-field>
            </td>

            <td>
              <mat-form-field class="selection" appearance="fill">
                <mat-label>{{
                  "Form.Field.TypeSolicitation" | translate
                }}</mat-label>
                <mat-select
                  id="integration"
                  name="integration"
                  [(ngModel)]="integration"
                  required
                >
                  <mat-option
                    option
                    *ngFor="let ts of typeSolicitation"
                    value="{{ ts.key }}"
                  >
                    {{ ts.label | translate }}</mat-option
                  >
                </mat-select>
                <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
              </mat-form-field>
            </td>
          </tr>
        </table>
      </div>

      <!-- form insights -->
      <div *ngIf="integration === 'false'">
        <table class="username" cellspacing="0">
          <tr>
            <td>
              <mat-form-field
                class="summary"
                hintLabel="{{ 'Form.Placeholder.Max' | translate }}"
                appearance="fill"
              >
                <mat-label>{{ "Form.Field.Summary" | translate }}</mat-label>
                <input
                  matInput
                  #input
                  name="summary"
                  [(ngModel)]="form.summary"
                  maxlength="150"
                  required
                />
                <mat-hint align="end"
                  >{{ input.value?.length || 0 }}/150</mat-hint
                >
                <mat-error>{{ "Form.Warning.Empty" | translate }} </mat-error>
              </mat-form-field>
            </td>
          </tr>
        </table>
        <div class="first-form">
          <table class="full-width" cellspacing="0">
            <tr>
              <td class="">
                <mat-form-field class="selection" appearance="fill">
                  <mat-label>{{ "Form.Field.Product" | translate }}</mat-label>
                  <mat-select
                    id="project"
                    name="project"
                    [(ngModel)]="form.project"
                    (ngModelChange)="filterSubjects()"
                    required
                  >
                    <mat-option
                      *ngFor="let product of products"
                      value="{{ product.key }}"
                    >
                      {{ product.label | translate }}
                    </mat-option>
                  </mat-select>
                  <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
                </mat-form-field>
              </td>

              <td>
                <mat-form-field class="selection" appearance="fill">
                  <mat-label>{{ "Form.Field.subject" | translate }}</mat-label>
                  <mat-select
                    id="subject"
                    name="subject"
                    [(ngModel)]="form.subject"
                    required
                  >
                    <mat-option
                      *ngFor="let filteredSubject of filteredSubjects"
                      value="{{ filteredSubject.key }}"
                    >
                      {{ filteredSubject.label | translate }}
                    </mat-option>
                  </mat-select>
                  <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
                </mat-form-field>
              </td>

              <td>
                <mat-form-field class="selection" appearance="fill">
                  <mat-label>{{ "Form.Field.Process" | translate }}</mat-label>
                  <mat-select
                    id="process"
                    name="process"
                    multiple
                    [(ngModel)]="form.process"
                    required
                  >
                    <mat-option
                      *ngFor="let process of processes"
                      value="{{ process.key }}"
                    >
                      {{ process.label | translate }}
                    </mat-option>
                  </mat-select>
                  <mat-error>{{
                    "Form.Warning.MultiItems" | translate
                  }}</mat-error>
                </mat-form-field>
              </td>

              <td>
                <mat-form-field class="selection" appearance="fill">
                  <mat-label>{{ "Form.Field.Benefit" | translate }}</mat-label>
                  <mat-select
                    id="benefit"
                    name="benefit"
                    multiple
                    [(ngModel)]="form.benefit"
                    required
                  >
                    <mat-option
                      *ngFor="let benefit of benefits"
                      value="{{ benefit.key }}"
                    >
                      {{ benefit.label | translate }}
                    </mat-option>
                  </mat-select>
                  <mat-error>{{
                    "Form.Warning.MultiItems" | translate
                  }}</mat-error>
                </mat-form-field>
              </td>
            </tr>
          </table>

          <table class="full-width" cellspacing="0">
            <tr>
              <td>
                <mat-form-field class="selection" appearance="fill">
                  <mat-label>{{ "Form.Field.Sector" | translate }}</mat-label>
                  <mat-select
                    id="sector"
                    name="sector"
                    [(ngModel)]="form.sector"
                    required
                  >
                    <mat-option
                      option
                      *ngFor="let sector of sectors"
                      value="{{ sector.key }}"
                    >
                      {{ sector.label | translate }}</mat-option
                    >
                  </mat-select>
                  <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
                </mat-form-field>
              </td>

              <td>
                <mat-form-field class="selection" appearance="fill">
                  <mat-label>{{
                    "Form.Field.ClientSolicitation" | translate
                  }}</mat-label>
                  <mat-select
                    id="clientSolicit"
                    name="clientSolicit"
                    [(ngModel)]="form.clientSolicit"
                    required
                  >
                    <mat-option
                      option
                      *ngFor="let cs of ClientSolicitation"
                      value="{{ cs.key }}"
                    >
                      {{ cs.label | translate }}</mat-option
                    >
                  </mat-select>
                  <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
                </mat-form-field>
              </td>

              <td *ngIf="form.clientSolicit == 'Sim'" class="tooltip">
                <mat-form-field class="selection" appearance="fill">
                  <mat-label>{{
                    "Form.Field.SectorClient" | translate
                  }}</mat-label>
                  <mat-select
                    id="sectorClient"
                    name="sectorClient"
                    [(ngModel)]="form.sectorClient"
                  >
                    <mat-option
                      option
                      *ngFor="let sc of sectorsClients"
                      value="{{ sc.key }}"
                    >
                      {{ sc.label | translate }}</mat-option
                    >
                  </mat-select>
                  <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
                </mat-form-field>
              </td>

              <td *ngIf="form.clientSolicit == 'Sim'">
                <mat-form-field class="selection" appearance="fill">
                  <mat-label>{{ "Form.Field.Company" | translate }}</mat-label>
                  <input
                    matInput
                    #input
                    name="company"
                    [(ngModel)]="form.company"
                  />
                  <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
                </mat-form-field>
              </td>
            </tr>
          </table>

          <table class="full-width" cellspacing="0">
            <td>
              <mat-form-field class="selection" appearance="fill">
                <mat-label>{{
                  "Form.Field.ImpactLevel" | translate
                }}</mat-label>
                <mat-select
                  id="impact"
                  name="impact"
                  [(ngModel)]="form.impact"
                  required
                >
                  <mat-option
                    option
                    *ngFor="let level of levels"
                    value="{{ level.key }}"
                  >
                    {{ level.label | translate }}</mat-option
                  >
                </mat-select>
                <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
              </mat-form-field>
            </td>

            <td>
              <mat-form-field class="selection" appearance="fill">
                <mat-label>{{
                  "Form.Field.AffectedUsers" | translate
                }}</mat-label>
                <mat-select
                  id="affected"
                  name="affected"
                  [(ngModel)]="form.affected"
                  required
                >
                  <mat-option
                    option
                    *ngFor="let level of levelsUser"
                    value="{{ level.key }}"
                  >
                    {{ level.label | translate }}</mat-option
                  >
                </mat-select>
                <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
              </mat-form-field>
            </td>

            <td>
              <mat-form-field class="selection" appearance="fill">
                <mat-label>{{ "Form.Field.Urgency" | translate }}</mat-label>
                <mat-select
                  id="urgency"
                  name="urgency"
                  [(ngModel)]="form.urgency"
                  required
                >
                  <mat-option
                    *ngFor="let level of levelsF"
                    value="{{ level.key }}"
                  >
                    {{ level.label | translate }}</mat-option
                  >
                </mat-select>
                <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
              </mat-form-field>
            </td>

            <td>
              <mat-form-field class="selection" appearance="fill">
                <mat-label>{{
                  "Form.Field.returnValue" | translate
                }}</mat-label>
                <mat-select
                  id="returnValue"
                  name="returnValue"
                  [(ngModel)]="form.returnValue"
                  required
                >
                  <mat-option
                    *ngFor="let rv of ReturnValues"
                    value="{{ rv.key }}"
                  >
                    {{ rv.label | translate }}</mat-option
                  >
                </mat-select>
                <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
              </mat-form-field>
            </td>
          </table>
        </div>

        <div class="spacer"></div>

        <div class="upload-form">
          <table class="full-width" cellspacing="0">
            <tr>
              <td>
                <mat-form-field class="upload-field">
                  <ngx-mat-file-input
                    id="upload"
                    #removableInput
                    placeholder="{{ 'Form.Placeholder.Attach' | translate }}"
                    [multiple]="true"
                  >
                  </ngx-mat-file-input>
                  <mat-icon matSuffix>folder</mat-icon>
                  <button
                    mat-icon-button
                    matSuffix
                    *ngIf="!removableInput.empty"
                    (click)="removableInput.clear($event)"
                  >
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </td>
            </tr>
          </table>
        </div>
        <div class="longtext-form">
          <mat-form-field class="long-text">
            <mat-label>{{
              "Form.Field.returnValueAnswer" | translate
            }}</mat-label>
            <textarea
              id="returnValueAnswer"
              matInput
              placeholder="{{
                'Form.Placeholder.returnValueAnswer' | translate
              }}"
              name="returnValueAnswer"
              [(ngModel)]="form.returnValueAnswer"
              required
            ></textarea>
            <mat-error>{{ "Form.Warning.Empty" | translate }} </mat-error>
          </mat-form-field>

          <section *ngIf="form.benefit == 'Outro'">
            <mat-form-field class="long-text">
              <mat-label>{{ "Form.Field.OtherBenefit" | translate }}</mat-label>
              <textarea
                id="otherbenefit"
                matInput
                placeholder="{{ 'Form.Placeholder.OtherBenefit' | translate }}"
                name="otherbenefit"
                [(ngModel)]="form.otherbenefit"
              ></textarea>
              <mat-error>{{ "Form.Warning.Empty" | translate }} </mat-error>
            </mat-form-field>
          </section>

          <section *ngIf="form.clientSolicit == 'Sim'">
            <mat-form-field class="long-text">
              <mat-label>{{ "Form.Field.CustomerData" | translate }}</mat-label>
              <textarea
                id="CustomerData"
                matInput
                placeholder="{{ 'Form.Placeholder.CustomerData' | translate }}"
                name="CustomerData"
                [(ngModel)]="form.CustomerData"
              ></textarea>
              <mat-error>{{ "Form.Warning.Empty" | translate }} </mat-error>
            </mat-form-field>
          </section>

          <section class="tooltip">
            <mat-form-field class="long-text">
              <mat-label>{{ "Form.Field.Situation" | translate }}</mat-label>
              <textarea
                id="situation"
                matInput
                placeholder="{{ 'Form.Placeholder.Situation' | translate }}"
                name="situation"
                [(ngModel)]="form.situation"
                required
              ></textarea>
              <mat-error>{{ "Form.Warning.Empty" | translate }} </mat-error>
            </mat-form-field>
            <button
              matTooltip="{{ 'Form.Tooltip.Situation' | translate }}"
              matTooltipClass="tooltip-uppercase"
              aria-label="Button that shows a red tooltip"
              class="tooltip-button"
            >
              ?
            </button>
          </section>

          <section class="tooltip">
            <mat-form-field class="long-text">
              <mat-label>{{ "Form.Field.Customerneed" | translate }}</mat-label>
              <textarea
                id="Customerneed"
                matInput
                placeholder="{{ 'Form.Placeholder.Customerneed' | translate }}"
                name="Customerneed"
                [(ngModel)]="form.Customerneed"
                required
              ></textarea>
              <mat-error>{{ "Form.Warning.Empty" | translate }} </mat-error>
            </mat-form-field>
            <button
              matTooltip="{{ 'Form.Tooltip.Customerneed' | translate }}"
              matTooltipClass="tooltip-uppercase"
              aria-label="Button that shows a red tooltip"
              class="tooltip-button"
            >
              ?
            </button>
          </section>

          <section class="tooltip">
            <mat-form-field class="long-text">
              <mat-label>{{ "Form.Field.Impact" | translate }}</mat-label>
              <textarea
                id="impact2"
                matInput
                placeholder="{{ 'Form.Placeholder.Impact' | translate }}"
                name="impact2"
                required
                [(ngModel)]="form.impact2"
                required
              ></textarea>
              <mat-error>{{ "Form.Warning.Empty" | translate }} </mat-error>
            </mat-form-field>
            <button
              matTooltip="{{ 'Form.Tooltip.Impact' | translate }}"
              matTooltipClass="tooltip-uppercase"
              aria-label="Button that shows a red tooltip"
              class="tooltip-button"
            >
              ?
            </button>
          </section>

          <section class="tooltip">
            <mat-form-field class="long-text">
              <mat-label>{{
                "Form.Field.CurrentBehavior" | translate
              }}</mat-label>
              <textarea
                id="Currentbehavior"
                matInput
                placeholder="{{
                  'Form.Placeholder.CurrentBehavior' | translate
                }}"
                name="Currentbehavior"
                required
                [(ngModel)]="form.Currentbehavior"
                required
              ></textarea>
              <mat-error>{{ "Form.Warning.Empty" | translate }} </mat-error>
            </mat-form-field>
            <button
              matTooltip="{{ 'Form.Tooltip.CurrentBehavior' | translate }}"
              matTooltipClass="tooltip-uppercase"
              aria-label="Button that shows a red tooltip"
              class="tooltip-button"
            >
              ?
            </button>
          </section>

          <section class="tooltip">
            <mat-form-field class="long-text">
              <mat-label>{{ "Form.Field.Alternatives" | translate }}</mat-label>
              <textarea
                id="alternatives"
                matInput
                placeholder="{{ 'Form.Placeholder.Alternatives' | translate }}"
                name="alternatives"
                [(ngModel)]="form.alternatives"
                required
              ></textarea>
              <mat-error>{{ "Form.Warning.Empty" | translate }} </mat-error>
            </mat-form-field>
            <button
              matTooltip="{{ 'Form.Tooltip.Alternatives' | translate }}"
              matTooltipClass="tooltip-uppercase"
              aria-label="Button that shows a red tooltip"
              class="tooltip-button"
            >
              ?
            </button>
          </section>

          <section class="tooltip">
            <mat-form-field class="long-text">
              <mat-label>{{ "Form.Field.Solution" | translate }}</mat-label>
              <textarea
                id="solution"
                matInput
                placeholder="{{ 'Form.Placeholder.Solution' | translate }}"
                name="solution"
                [(ngModel)]="form.solution"
                required
              ></textarea>
              <mat-error>{{ "Form.Warning.Empty" | translate }} </mat-error>
            </mat-form-field>
            <button
              matTooltip="{{ 'Form.Tooltip.Solution' | translate }}"
              matTooltipClass="tooltip-uppercase"
              aria-label="Button that shows a red tooltip"
              class="tooltip-button"
            >
              ?
            </button>
          </section>

          <section class="tooltip">
            <mat-form-field class="long-text">
              <mat-label>{{ "Form.Field.Results" | translate }}</mat-label>
              <textarea
                id="results"
                matInput
                placeholder="{{ 'Form.Placeholder.Results' | translate }}"
                name="results"
                [(ngModel)]="form.results"
                required
              ></textarea>
              <mat-error>{{ "Form.Warning.Empty" | translate }} </mat-error>
            </mat-form-field>
            <button
              matTooltip="{{ 'Form.Tooltip.Results' | translate }}"
              matTooltipClass="tooltip-uppercase"
              aria-label="Button that shows a red tooltip"
              class="tooltip-button"
            >
              ?
            </button>
          </section>

          <td>
            <app-file-upload
              (imageSelected)="onImageSelected($event)"
            ></app-file-upload>
          </td>
          <p>Arquivos Selecionados: {{ selectedFiles.length }}</p>
          <ul>
            <li *ngFor="let fileName of selectedFiles">{{ fileName.name }}</li>
          </ul>
        </div>
        <div class="submit">
          <button mat-raised-button type="submit" [disabled]="!f.valid">
            {{ "Form.Button.Submit" | translate }}
          </button>
        </div>
      </div>

      <!-- form integration -->
      <div *ngIf="integration === 'true'">
        <h1>{{ "Form.Field.Solicitation" | translate }}</h1>
        <table>
          <td>
            <mat-form-field class="selection" appearance="fill">
              <mat-label>{{
                "Form.FieldIntegration.NameCompany" | translate
              }}</mat-label>
              <input
                matInput
                #input
                name="companyName"
                [(ngModel)]="integrationform.companyName"
              />
              <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="selection" appearance="fill">
              <mat-label>{{
                "Form.FieldIntegration.ContactName" | translate
              }}</mat-label>
              <input
                matInput
                #input
                name="contactClient"
                [(ngModel)]="integrationform.contactClient"
              />
              <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="selection" appearance="fill">
              <mat-label>{{
                "Form.FieldIntegration.ContactPhone" | translate
              }}</mat-label>
              <input
                matInput
                #input
                name="contactPhone"
                [(ngModel)]="integrationform.contactPhone"
              />
              <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="selection" appearance="fill">
              <mat-label>{{
                "Form.FieldIntegration.ContactEmail" | translate
              }}</mat-label>
              <input
                matInput
                #input
                name="contactEmail"
                [(ngModel)]="integrationform.contactEmail"
              />
              <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="selection" appearance="fill">
              <mat-label>{{
                "Form.FieldIntegration.SectorClient" | translate
              }}</mat-label>
              <mat-select
                id="sectorClients"
                name="sectorClients"
                [(ngModel)]="integrationform.sectorClient"
              >
                <mat-option
                  option
                  *ngFor="let sc of sectors"
                  value="{{ sc.key }}"
                >
                  {{ sc.label | translate }}</mat-option
                >
              </mat-select>
              <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
            </mat-form-field>
          </td>
        </table>
        <table>
          <td>
            <mat-form-field class="selection" appearance="fill">
              <mat-label>{{
                "Form.FieldIntegration.Erp" | translate
              }}</mat-label>
              <mat-select
                id="erp"
                name="erp"
                [(ngModel)]="integrationform.erp"
              >
                <mat-option
                  option
                  *ngFor="let el of erpList"
                  value="{{ el.key }}"
                >
                  {{ el.label | translate }}</mat-option
                >
              </mat-select>
              <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
            </mat-form-field>
          </td>
          <!-- campo de outros ERP -->
          <td *ngIf="integrationform.erp === 'Outros'"> 
            <mat-form-field class="selection" appearance="fill">
              <mat-label>{{
                "Form.FieldIntegration.OtherErp" | translate
              }}</mat-label>
              <input
                matInput
                #input
                name="nameOtherErp"
                [(ngModel)]="integrationform.nameOtherErp"
              />
              <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="selection" appearance="fill">
              <mat-label>{{
                "Form.FieldIntegration.ErpResponse" | translate
              }}</mat-label>
              <input
                matInput
                #input
                name="erpResponse"
                [(ngModel)]="integrationform.erpResponse"
              />
              <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="selection" appearance="fill">
              <mat-label>{{
                "Form.FieldIntegration.SolicitationDate" | translate
              }}</mat-label>
              <input
                matInput
                #input
                type="date"
                name="solicitationDate"
                [(ngModel)]="integrationform.solicitationDate"
              />
              <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="selection" appearance="fill">
              <mat-label>{{
                "Form.FieldIntegration.StartForecast" | translate
              }}</mat-label>
              <input
                matInput
                #input
                type="date"
                name="startForecast"
                [(ngModel)]="integrationform.startForecast"
              />
              <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
            </mat-form-field>
          </td>
        </table>
        <table>
          <td>
            <mat-form-field class="selection" appearance="fill">
              <mat-label>{{
                "Form.FieldIntegration.ProjectResponse" | translate
              }}</mat-label>
              <input
                matInput
                #input
                name="projectResponse"
                [(ngModel)]="integrationform.projectResponse"
              />
              <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
            </mat-form-field>
          </td>
          <!-- perfil do cliente -->
          <td>
            <mat-form-field class="selection" appearance="fill">
              <mat-label>{{
                "Form.FieldIntegration.clientProfile" | translate
              }}</mat-label>
              <mat-select
                id="clientProfiles"
                name="clientProfiles"
                [(ngModel)]="integrationform.clientProfile"
              >
                <mat-option
                  option
                  *ngFor="let tcp of typeClientProfile"
                  value="{{ tcp.key }}"
                >
                  {{ tcp.label | translate }}</mat-option
                >
              </mat-select>
              <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="selection" appearance="fill">
              <mat-label>{{
                "Form.FieldIntegration.ContactErp" | translate
              }}</mat-label>
              <mat-select
                id="contactErp"
                name="contactErp"
                [(ngModel)]="integrationform.contactErp"
              >
                <mat-option
                  option
                  *ngFor="let ct of contractTrain"
                  value="{{ ct.key }}"
                >
                  {{ ct.label | translate }}</mat-option
                >
              </mat-select>
              <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="selection" appearance="fill">
              <mat-label>{{
                "Form.FieldIntegration.ClientContractTrain" | translate
              }}</mat-label>
              <mat-select
                id="clientContractTrain"
                name="clientContractTrain"
                [(ngModel)]="integrationform.clientContractTrain"
              >
                <mat-option
                  option
                  *ngFor="let ct of contractTrain"
                  value="{{ ct.key }}"
                >
                  {{ ct.label | translate }}</mat-option
                >
              </mat-select>
              <mat-error>{{ "Form.Warning.Item" | translate }}</mat-error>
            </mat-form-field>
          </td>
        </table>
        <div class="submit">
          <button mat-raised-button type="submit" [disabled]="!f.valid">
            {{ "Form.Button.Submit" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
